// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__33hqk","inner":"Form_inner__3CRTq","range":"Form_range__iDuja","name":"Form_name__3_wuV","actions":"Form_actions__2t_Cz"};